import { Box, Chip, Typography } from '@mui/material'
import { List } from 'immutable'
import { FormattedMessage } from 'react-intl'
import { styles } from './styles'

enum ChipColor {
    DEFAULT,
    PRIMARY,
}

export type ChipOptions = {
    id: string
    label: React.ReactNode
    avatar?: React.ReactElement
    icon?: React.ReactElement
    actionIcon?: React.ReactElement
    onDelete?: () => void
    onClick?: () => void
    clickable?: boolean
    color?: ChipColor
}

type ChipListOptions = {
    outlined?: boolean
    small?: boolean
    maxShown?: number
    totalCount?: number
    onClickedMore?: () => void
}

export const ChipListComponent = ({
    options,
    items,
}: {
    options: ChipListOptions
    items: List<ChipOptions>
}): React.ReactElement => {
    const getObjectCount = (): number => {
        if (options.totalCount !== undefined) {
            return options.totalCount
        }

        return items.size
    }

    const getColor = (color?: ChipColor): 'primary' | 'default' | undefined => {
        if (color === undefined) {
            return undefined
        }

        switch (color) {
            case ChipColor.DEFAULT:
                return 'default'
            case ChipColor.PRIMARY:
                return 'primary'
            default:
                return 'default'
        }
    }

    return (
        <Box sx={styles.container}>
            {items.slice(0, options.maxShown).map((comp) => (
                <Box sx={styles.chip} key={comp.id}>
                    <Chip
                        variant={options.outlined ? 'outlined' : undefined}
                        size={options.small ? 'small' : undefined}
                        color={getColor(comp.color)}
                        onDelete={comp.onDelete}
                        onClick={comp.onClick}
                        label={comp.label}
                        deleteIcon={comp.actionIcon}
                        avatar={comp.avatar}
                        icon={comp.icon}
                        clickable={comp.clickable}
                    />
                </Box>
            ))}

            {options.maxShown && options.maxShown < getObjectCount() && (
                <Box component="button" type="button" sx={styles.moreChips} onClick={options.onClickedMore}>
                    <Typography>
                        <FormattedMessage
                            id="more_chips_msg"
                            defaultMessage="{more_count} More"
                            values={{ more_count: getObjectCount() - options.maxShown }}
                        />
                    </Typography>
                </Box>
            )}
        </Box>
    )
}

export default ChipListComponent
